module.exports = __webpack_public_path__ + "static/media/arrow_back_iframe.c7604979.svg";